"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertMaxChars = exports.DataRefRecordsMaxChars = void 0;
const plus_plus_plus_1 = require("./plus-plus-plus");
const utils_1 = require("../utils");
var constants_iso_1 = require("@wranggle/constants-iso");
Object.defineProperty(exports, "DataRefRecordsMaxChars", { enumerable: true, get: function () { return constants_iso_1.DataRefRecordsMaxChars; } });
function assertMaxChars(data, maxChars) {
    if (!data) {
        return;
    }
    const str = typeof data === 'string' ? data : utils_1.safeStringify(data); // meh, better way?
    if (str.length > maxChars) {
        throw new plus_plus_plus_1.PlusPlusPlus('MaxSizeExceeded', {
            maxChars,
        });
    }
}
exports.assertMaxChars = assertMaxChars;
//# sourceMappingURL=assert-max-size.js.map